import { LoadingButton } from "@mui/lab";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, TextField } from "@mui/material";
import React, { useState, useEffect, Fragment, useMemo } from "react";
interface ContactsSupportProps {
    open: boolean;
    loader: boolean;
    handleClose: () => void;
    userData:any;
    handleClickUpdate: (data:any) => void;
  }

export default function ContactsSupport({open,loader,handleClose,handleClickUpdate,userData}:ContactsSupportProps) {
    
    let details = {email: userData.attributes.email, name: userData.group === 'admin' ? userData.attributes.name : userData.name, role: userData.group, phone: userData.phone};    
    const [configData, setConfigData] = useState<any>({
        // email:"ketan123@yopmail.com",        
        email:"support@IEQmax.com",        
        details: JSON.stringify(details),
        subject:"Contact Support",        
        message:""
      });
    
    const [errorMessage, setErrorMessage] = useState<any>("");

    const handleUpdate = useMemo(() => {
        const saveData = (configData:any) => {
          if(configData.message !== '' && errorMessage == ''){
            handleClickUpdate(configData);
          }else{
            setErrorMessage('Please enter message') 
          }                      
        };
        return saveData;
    }, []);

    const handleChange = useMemo(() => {
      
        const handleChangeEvent = (event:any) => {  
          let value = event.target.value.trimLeft();    
           setConfigData({
            ...configData,
            [event.target.name] : value
           })
           if(value == ''){
            setErrorMessage('Please enter message')
           }else if(value.length <= 20){
            setErrorMessage('Please enter more then 20 charaters')
           }else if(value.length > 200){
            setErrorMessage('Please enter less then 200 charaters')
           }else {
            setErrorMessage('')
           }
        };
        return handleChangeEvent;
    }, [configData]);

  return (
    <Fragment>
      <Dialog open={open} onClose={handleClose} maxWidth="md">
        <DialogTitle>Contacts Support</DialogTitle>
        <DialogContent>
            <Grid container>
                <Grid item xs={12} sm={12}>                    
                    <TextField
                        disabled
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        value={configData.email}
                        onChange={handleChange}
                        // error={validateError.includes("tenant_name")}
                        // helperText={validateError.includes("tenant_name") && "Please Enter Valid Value" }
                    />                    
                </Grid>
                <Grid item xs={12} sm={12}>                    
                    <TextField
                        margin="normal"
                        multiline
                        required
                        fullWidth
                        id="message"
                        label="Message"
                        name="message"
                        autoComplete="message"
                        autoFocus
                        value={configData.message}
                        onChange={handleChange}
                        error={errorMessage !== '' ? true : false}
                        helperText={errorMessage}
                    />                    
                </Grid>                             
            </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <LoadingButton
            loading={loader}
            variant="contained"
            onClick={() => handleUpdate(configData)}
          >
            Submit
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </Fragment>
  )
}

